<template>
    <div>
        <div class="uk-grid table-filter">
            <div class="uk-width-1-2@xl uk-margin-small-bottom">
                <div class="uk-grid">
                    <div class="uk-width-1-2">
                        <label for="pf-search" class="uk-form-label">Search</label>
                        <div class="uk-form-controls">
                            <input id="pf-search" type="text" name="pf-search" value="" class="uk-input" v-model="searchTerm" placeholder="Enter Search Terms" />
                        </div>
                    </div>
                    <div class="uk-width-1-2">
                        <div class="uk-form-label">Filter Date Range</div>
                        <div class="uk-grid">
                            <div class="uk-width-1-2">
                                <datepicker ref="start_date" placeholder="Start Date" input-class="uk-input" @input="startUpdated" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                            </div>
                            <div class="uk-width-1-2">
                                <datepicker ref="end_date" placeholder="End Date" @input="endUpdated" input-class="uk-input" :use-utc=true :clear-button=true :typeable=true clear-button-icon="fa fa-times" format="MM/dd/yyyy"></datepicker>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="uk-form-label uk-margin-top">Narrow Search By</div>
                <div class="uk-margin uk-grid-medium uk-child-width-auto uk-grid">
                    <label>
                        PO Number
                        <input class="uk-checkbox" type="checkbox" value="po_number" v-model="checkedFilters" />
                    </label>
                    <label>
                        Req. #
                        <input class="uk-checkbox" type="checkbox" value="number" v-model="checkedFilters" />
                    </label>
                    <label>
                        Manager
                        <input class="uk-checkbox" type="checkbox" value="manager" v-model="checkedFilters" />
                    </label>
                    <label>
                        Customer
                        <input class="uk-checkbox" type="checkbox" value="customer" v-model="checkedFilters" />
                    </label>
                    <label>
                        Craft
                        <input class="uk-checkbox" type="checkbox" value="craft" v-model="checkedFilters" />
                    </label>
                    <label>
                        Job Number
                        <input class="uk-checkbox" type="checkbox" value="job_number" v-model="checkedFilters" />
                    </label>
                    <label>
                        Include Archived
                        <input class="uk-checkbox" type="checkbox" value="include_archived" v-model="checkedFilters" />
                    </label>
					<label v-if="showServiceLines">
						Service Lines
						<input class="uk-checkbox" type="checkbox" value="service_lines" v-model="checkedFilters" />
					</label>
                </div>
            </div>

            <div class="uk-width-1-4@xl uk-width-1-2@s uk-margin-small-bottom">
				<label class="uk-form-label">Business Unit:</label>
				<select class="uk-select" name="bu_id" v-model="businessUnitId">
					<option :value="-1">All</option>
					<option :value="0">Unassigned</option>
					<option v-for="bu in businessUnits" :value="bu.id">{{ bu.name }}</option>
				</select>
                <div class="uk-form-label uk-margin-small-top">Records Per Page</div>
                <select class="uk-select uk-width-1-4" v-model="perPage">
                    <option v-for="val in recordOptions" :value="val" >{{val}}</option>
                </select>
                <div class="uk-margin-top">
                    <button class="uk-button uk-button-small uk-margin-small-bottom" @click="clearFilters()">Clear Search/Filters</button>
					<span v-if="loading" class="uk-align-right">
                            <img style="width: 18px;" src="/images/spinner2.gif" /> Loading...
					</span>
                </div>
            </div>
            <div class="uk-width-1-4@xl uk-width-1-2@s uk-text-right@s">
                <button class="uk-button uk-button-tertiary uk-margin-small-left uk-margin-small-bottom" @click="submitArchive"><i class="fas fa-inbox"></i>Archive</button>
                <button class="uk-button uk-button-tertiary uk-margin-small-bottom" uk-toggle="target: #requisition-export" @click="openExporter()"><i class="fas fa-caret-square-down"></i>Export</button>
            </div>
        </div>
        <data-table
                ref="requisitionTable"
                :searchable="false"
                api_point="requisition/list"
                :per_page=perPage
                :table_headers="tableHeaders"
                :actions="{
                        pdf_path: '/requisitions/pdf',
                        download_path: '/requisitions/pdf-download',
                        export_path: '/requisitions/export',
                        zip_path: '/requisitions/zip',
                        delete_modal:{
                            modalId:deleteModalId,
                            formRef:deleteModalForm
                        }
                    }"
                multi_select=true
                storage-location="requisition_table"
        ></data-table>
		<!-- The following is the EXPORT POP-UP -->
        <div id="requisition-export" uk-modal class="requisition-export">
            <div class="uk-modal-dialog uk-modal-body">
                <h2 class="uk-modal-title uk-margin-medium-bottom">Batch Export
                    <div v-if="!all_items" class="uk-align-right@m uk-margin-remove-bottom recipients">
                        {{ selectedReqIds.length }} Records Selected
                    </div>
                    <div v-if="all_items" class="uk-align-right@m uk-margin-remove-bottom recipients">
                        All Records Selected
                    </div>
                </h2>

                <div class="uk-clearfix"></div>
                <form action="/requisitions/export" enctype="multipart/form-data" target="_blank" method="post">
                    <label class="uk-form-label header">Select columns to include</label>
                    <input type="hidden" name="_token" v-model="csrf">
                    <input type="hidden" name="req_ids" v-model="req_ids" />
                    <input type="hidden" v-if="all_items" name="all_items" value="1" />
                    <div class="uk-form-controls fields">
                        <label>
                            Requisition Number
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="number" checked />
                        </label>
                        <label>
                            Start Date
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="start_date" checked />
                        </label>
                        <label>
                            Manager
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="manager_name" checked />
                        </label>
                        <label>
                            Customer
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="customer" checked />
                        </label>
                        <label>
                            Craft(s)
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="crafts" checked />
                        </label>
                        <label>
                            Craft Codes
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="craft_codes" checked />
                        </label>
                        <label>
                            Business Unit
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="bu_name" checked />
                        </label>
                        <label>
                            Date Added
                            <input type="checkbox" class="uk-checkbox" name="fields[]" value="created_at" checked />
                        </label>
                    </div>
                    <div class="uk-margin-medium-bottom"></div>
                    <div class="uk-align-right">
                        <button class="uk-button uk-button-tertiary uk-modal-close" type="button"><i class="fas fa-times-circle"></i> Cancel</button>
                        <button class="uk-button uk-button-primary" type="submit"><i class="fas fa-caret-square-down"></i> Export to CSV</button>
                    </div>
                </form>
            </div>
        </div>
    </div>

</template>

<script>
    // import any required components
    import DataTable from "../Table/DataTable";
    import _ from 'lodash';
    import GlobalStorage from "../../Classes/GlobalStorage";
	import Datepicker from "vuejs-datepicker";

    // export component
    export default {
        props: {
            deleteModalId:{type:String},
            deleteModalForm:{type:String},
            csrf:{type:String},
			showServiceLines:{
				type:Boolean,
				default: false
			}
        },

        components: {
            DataTable,
			Datepicker
        },

        data() {
            return {
                useAPI: true,
                perPage: 30,
                startDate: null,
                endDate: null,
                recordOptions: [10,15,30,50],
                checkedFilters: [],
                searchTerm: "",
                typeCount: 0,
                selectedReqIds:[],
                req_ids: "",
                all_items: false,
                storageName:"requisition_settings",
                loadingStorage:false,
				businessUnits: [],
				businessUnitId: null,
				loading: false,
				tableHeaders:{number:{display:'Requisition',route:'/requisitions/view/{id}',format:'edit_fallback'},
					customer: {display:'Customer'},
					name: {display:'Job Name'},
					job_number:{display:'Job Number'},
					start_date:{display:'Start Date'},
					end_date:{display:'Completion Date'},
					created_at:{display:'Creation Date'},
					manager_name:{display:'Manager'},
					user_names:{display:'Users', sortable: false},
					status:{display:'Status'},
					fill_level: {display:'Filled/Need', sortable: false, component:'FilledJobCell'}
				}
            };
        },

        mounted(){
            this.loadStorage();
            this.loadBusinessUnits();
			this.$refs.requisitionTable.setPreSearchCallback(this.searchStarting);
			this.$refs.requisitionTable.setSearchCallback(this.searchComplete);

			if(this.showServiceLines){
				this.tableHeaders = {number:{display:'Requisition',route:'/requisitions/view/{id}',format:'edit_fallback'},
					customer: {display:'Customer'},
					name: {display:'Job Name'},
					job_number:{display:'Job Number'},
					start_date:{display:'Start Date'},
					end_date:{display:'Completion Date'},
					created_at:{display:'Creation Date'},
					service_lines:{display:'Service Line(s)'},
					manager_name:{display:'Manager'},
					user_names:{display:'Users', sortable: false},
					status:{display:'Status'},
					fill_level: {display:'Filled/Need', sortable: false, component:'FilledJobCell'}
				};
			}
        },

        methods: {
            startSearch(){
                let sd = null;
                let ed = null;
                if(this.startDate){
                    sd = this.startDate.getUTCFullYear() + "-" + (this.startDate.getUTCMonth()+1) + "-" + this.startDate.getUTCDate();
                }
                if(this.endDate){
                    ed = this.endDate.getUTCFullYear() + "-" + (this.endDate.getUTCMonth()+1) + "-" + this.endDate.getUTCDate();
                }
                this.$refs.requisitionTable.startCustomSearch(

                    {
                        q: this.searchTerm,
                        filters: this.checkedFilters.join(","),
                        start: sd,
                        end: ed,
						bu_id: this.businessUnitId == -1 ? null:this.businessUnitId
                    }
                );
                this.saveStorage();
            },
            apiSearch(){
                this.typeCount--;
                if(this.typeCount <= 0){
                    !this.loadingStorage ? this.startSearch():null;
                    this.loadingStorage = false;
                }
            },
			loadBusinessUnits(){
				axios.get("/api/bu/list").then(
					ax => this.updateBusinessUnits(ax),
					ax => this.updateBusinessUnits(ax))
			},
			updateBusinessUnits(pack) {
				if(pack.data.success){
					this.businessUnits = pack.data.data;
				}

				if(GlobalStorage.has("req_business_unit")){
					let buId = GlobalStorage.load("req_business_unit");
					if(this.businessUnits.length > 0){
						for(let i = 0; i < this.businessUnits.length;++i){
							let bu = this.businessUnits[i];
							if(bu.id == buId){
								this.businessUnitId = buId;
								break;
							}
						}
					}
					if(buId === 0 || buId === -1){
						this.businessUnitId = buId;
					}
				}
				if(this.businessUnitId == null){
					this.businessUnitId = -1;
				}
			},
            clearFilters(){
                this.searchTerm = "";
                this.checkedFilters = [];
                this.startDate = null;
                this.endDate = null;
                this.$refs.start_date.selectedDate = null;
                this.$refs.end_date.selectedDate = null;
				this.$refs["requisitionTable"].clearStorage();
                GlobalStorage.save(this.storageName, null); //force clearing out in case it gets "stuck"
            },
            startUpdated(date){
                this.startDate = date;
            },
            endUpdated(date){
                this.endDate = date;
            },
            submitArchive(){
                axios.post("/api/requisitions/archive", {rids: this.$refs.requisitionTable.selectedRows})
                    .then(() => this.startSearch());
            },
            openExporter(){
                this.selectedReqIds = this.$refs.requisitionTable.selectedRows;
                this.req_ids = this.selectedReqIds.join(",");
                this.all_items = this.$refs.requisitionTable.allSelected;
            },
            loadStorage(){
                if(GlobalStorage.has(this.storageName)){
                    this.loadingStorage = true;
                    let storedData = GlobalStorage.load(this.storageName);
                    this.searchTerm = storedData.searchTerm;
                    this.checkedFilters = storedData.checkedFilters;
                    this.startDate = storedData.startDate;
                    this.endDate = storedData.endDate;
                    this.perPage = storedData.perPage;
                    this.$refs.start_date.selectedDate = storedData.startDate;
                    this.$refs.end_date.selectedDate = storedData.endDate;
                }
            },
            saveStorage(){
                let data = {
                    searchTerm: this.searchTerm,
                    checkedFilters: this.checkedFilters,
                    startDate: this.startDate,
                    endDate: this.endDate,
                    perPage: this.perPage
                };
                GlobalStorage.save(this.storageName, data);
            },
			searchStarting(){
            	this.loading = true;
			},
			searchComplete(){
            	this.loading = false;
			},
        },

        watch: {
            searchTerm() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }

            },
            startDate() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            endDate() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            checkedFilters() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
            perPage() {
                if (this.useAPI) {
                    this.typeCount++;
                    setTimeout(() => this.apiSearch(), 400);
                } else {
                    this.startSearch();
                }
            },
			businessUnitId(){
				if(this.businessUnitId != null && typeof this.businessUnitId != "undefined"){
					this.startSearch();
					GlobalStorage.save("req_business_unit", this.businessUnitId);
				}
			},
        }
    };

</script>
